import { useAuthStore, PATH_DICTIONARY, useLogout } from '~/domains/auth';
import { useDomainRedirect } from '~/infrastructure';
import type { RouteLocationNormalized } from 'vue-router';

export const loginFromAppGuard = async (
  to: RouteLocationNormalized,
): Promise<boolean> => {
  const isLoginFromApp =
    to.path === PATH_DICTIONARY.login && to.query.source === 'app';

  if (!isLoginFromApp) {
    return false;
  }

  const { needLogout } = to.query;

  if (needLogout === 'true') {
    const { logout } = useLogout();

    await logout(false);
  } else {
    const { getAuthToken } = useAuthStore();
    const token = getAuthToken();

    const { handleRedirectToApp } = useDomainRedirect();

    if (token !== null) {
      handleRedirectToApp(token);
    }
  }

  return true;
};
